<template>
  <div>
    <ClientSelection
      v-if="displayClientSelection"
      @closeClientSelection="closeClientSelectionHandler"
      @cancelSelection="cancelSelectionHandler"
    />
    <div id="home">
      <SecondaryHeader>
        <template #content> {{ $t('dashboard') }} </template>
      </SecondaryHeader>
      <div
        class="atb-flex atb-flex-row atb-flex-wrap atb-justify-center atb-content-center atb-gap-8 atb-py-8"
      >
        <Card class="atb-w-1/4 atb-items-center atb-text-center">
          <template #body>
            <router-link
              to="client"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/client.svg"
                alt="Client icon"
              />
              <h4 class="atb-text-lg">
                <a href="#"> {{ $t('client') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('clientSummary') }}
              </p>
              <br />
            </router-link>
          </template>
        </Card>
        <Card
          v-if="AccessGuard.hasAccess('DEPLOY')"
          class="atb-w-1/4 atb-items-center atb-text-center"
        >
          <template #body>
            <router-link
              to="systems"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/systems.svg"
                alt="Systems icon"
              />
              <h4 class="atb-text-lg">
                <a href="#"> {{ $t('systems') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('systemSummary') }}
              </p>
            </router-link>
          </template>
        </Card>
        <Card
          v-if="AccessGuard.hasAccess('ATTRIBUTES_OR_FILTERS_CODE')"
          class="atb-w-1/4 atb-items-center atb-text-center"
        >
          <template #body>
            <router-link
              to="attributes"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/attributes.svg"
                alt="Attributes icon"
              />
              <h4 class="atb-text-lg">
                <a href="#">{{ $t('attributes') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('attributesSummary') }}
              </p>
            </router-link>
          </template>
        </Card>
        <Card
          v-if="AccessGuard.hasAccess('ATTRIBUTES_OR_FILTERS_CODE')"
          class="atb-w-1/4 atb-items-center atb-text-center"
        >
          <template #body>
            <router-link
              to="filters"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/filter.svg"
                alt="Filters icon"
              />
              <h4 class="atb-text-lg">
                <a href="#">{{ $t('filters') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('filtersSummary') }}
              </p>
            </router-link>
          </template>
        </Card>
        <Card class="atb-w-1/4 atb-items-center atb-text-center">
          <template #body>
            <router-link
              to="tools"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/tools.svg"
                alt="Tools icon"
              />
              <h4 class="atb-text-lg">
                <a href="#">{{ $t('tools') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('toolsSummary') }}
              </p>
            </router-link>
          </template>
        </Card>
        <Card
          class="atb-w-1/4 atb-items-center atb-text-center"
          v-if="enableCreditAttributeTrackerFeature"
        >
          <template #body>
            <a
              href="https://analyticsviz.experian.com/#/site/CAT/views/PremierAttributes1_3UAGReport/Home?:iid=1"
              target="blank"
              class="atb-flex atb-flex-col atb-gap-4 atb-items-center atb-no-underline atb-pt-4"
            >
              <img
                class="icon atb-w-12 atb-h-12"
                src="@/app/images/pencil.svg"
                alt="Pencil icon"
              />
              <h4 class="atb-text-lg">
                <a href="#">{{ $t('creditAttributeTracker') }}</a>
              </h4>
              <p class="card-text atb-text-black">
                {{ $t('creditAttributeTrackerSummary') }}
              </p>
            </a>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import ClientSelection from '@/app/features/ams/client/ClientSelection.vue';
  import SecondaryHeader from '@atb-ui/eds-vue/src/components/SecondaryHeader.vue';
  import Card from '@atb-ui/eds-vue/src/components/Card.vue';
  import { useClientStore } from '@/app/features/ams/client/client-store';
  import AccessGuard from '@/app/shared/guards/access-guard';

  const router = useRouter();
  const clientStore = useClientStore();
  const displayClientSelection = ref(false);
  const enableCreditAttributeTrackerFeature =
    config.ENABLE_CREDIT_ATTRIBUTE_TRACKER_FEATURE;

  let clientList: any;

  const closeClientSelectionHandler = () => {
    displayClientSelection.value = false;
  };

  const cancelSelectionHandler = () => {
    displayClientSelection.value = false;
    router.push({ name: 'base-home' });
  };

  clientStore.getSelectedClient.id === -1 &&
    clientStore
      .fetchClientData()
      .then(() => {
        clientList = clientStore.getClientList;
      })
      .finally(() => {
        displayClientSelection.value = true;
      });
</script>

<style>
  .card-content {
    box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
  }
</style>
